import React, { useState, useRef, useEffect } from 'react';
import Lg from '../assets/img/abstract/saloon.png';
import { getConfig } from '../config';
import { useLoginSettings } from '../contexts/loginSettingsContext';
import useDarkMode from '../hooks/useDarkMode';
const Logo = () => {
	const { loginSettings } = useLoginSettings();
const { darkModeStatus } = useDarkMode();
	return (
		<img
			style={{ width: '160px', height: '40px', objectFit: 'contain' }}
			src={darkModeStatus ? loginSettings.site_logo_dark : loginSettings.site_logo}
			// src={loginSettings.site_logo}
			alt='Site Logo'
		/>
	);
};
Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
